// Initialize Segment analytics through our backend proxy to bypass ad blockers.
// The stub is set up in index.html (queues events immediately).
// This module calls analytics.load() with proxy URLs so the actual script
// and all tracking requests go through our first-party domain.

const WRITE_KEY = 'bscuj5tKTCK1F1NU9tBT1T8Ygg9Z79b4';
const apiBase = import.meta.env.VITE_API_URL || '';

// CDN proxy: serves analytics.js from our backend
const cdnURL = `${apiBase}/t/js`;

// API proxy: forwards track/identify/page calls through our backend
// apiHost expects "host/path" without protocol - analytics.js prepends https://
const apiHost = apiBase
  ? new URL(apiBase).host + '/t/v1'
  : window.location.host + '/t/v1';

window.analytics?.load?.(WRITE_KEY, {
  cdnURL,
  integrations: {
    'Segment.io': {
      apiHost,
      protocol: 'https',
    },
  },
});
